import React, { FC, Fragment, MouseEventHandler, ReactNode } from "react";

import PageWrapper from "../PageWrapper/PageWrapper";
import Logo from "../Logo";

import ErrorBar from "../ErrorBar";

import { StyledHeader, StyledLayout } from "./PageLayout.styled";

type Props = {
    children: ReactNode;
    title?: string;
    progress?: number;
    errorMessage?: string | null;
    initiatorLogoUrl?: string;
    initiatorName?: string;

    navigateBack?: MouseEventHandler<HTMLElement>;
    clearBannerError?: MouseEventHandler<HTMLElement>;
};

const PageLayout: FC<Props> = ({
    children,
    title = "",
    errorMessage = "",
    navigateBack,
    clearBannerError,
}: Props) => (
    <PageWrapper
        title={title}
        header={
            <>
                {/* TODO error bar should timeout after 10 seconds */}
                <ErrorBar message={errorMessage} onClick={clearBannerError} />

                <StyledHeader>
                    {navigateBack && (
                        // <BackButton onClick={navigateBack}>Back!</BackButton>
                        <button onClick={navigateBack}>Back!</button>
                    )}

                    <Logo />
                </StyledHeader>
            </>
        }
    >
        <StyledLayout>{children}</StyledLayout>
    </PageWrapper>
);

export default PageLayout;
